// 模板 9：文旅与景区智慧管理平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner1.png'),
        path: '',
        title: '智慧景区运营平台',
        content:
          '整合票务、客流与运营数据，助力景区实现智慧化管理。'
      },
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '游客体验全面升级',
        content:
          '通过线上服务与导览工具，让游客玩得更放心、更轻松。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '客流与运营数据中心',
      subtitle: '/ Tourism Data Center',
      paragraphs: [
        '平台实时汇聚票务、客流与消费数据，为景区管理提供实时决策依据。',
        '通过可视化大屏呈现高峰时段与热门区域，辅助景区进行人流疏导与资源调配。'
      ],
      buttonText: '预约景区方案'
    },
    contact: {
      title: '文旅目的地数字化合作伙伴',
      subTitle: '让每一位游客的旅程更美好',
      buttonText: '联系文旅顾问'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '山海文旅科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__深耕文旅与景区行业，围绕票务、客流与营销三大方向提供一体化数字化平台。',
      '团队成员拥有多地景区与文旅项目实践经验，能够结合在地文化特点进行方案设计。'
    ]
  },
  news: [
    {
      id: 'T01',
      title: '大型山地景区智慧票务系统上线',
      introduce:
        '项目支持多渠道售票与分时预约，有效缓解节假日高峰拥堵问题。',
      date: '04-03',
      year: '2024'
    },
    {
      id: 'T02',
      title: '城市文旅一卡通项目成功交付',
      introduce:
        '打通多景区与文旅场馆票务系统，提升游客出行便利性。',
      date: '10-19',
      year: '2023'
    },
    {
      id: 'T03',
      title: '智慧导览小程序新增多语种支持',
      introduce:
        '为境外游客提供更加友好的导览体验，提升景区国际化服务能力。',
      date: '07-07',
      year: '2023'
    },
    {
      id: 'T04',
      title: '文旅消费数据分析报告正式发布',
      introduce:
        '联合多家景区梳理游客消费行为特征，为文旅产品设计提供参考。',
      date: '12-28',
      year: '2022'
    },
    {
      id: 'T05',
      title: '加入文旅数字化生态联盟',
      introduce:
        '与多家文旅服务机构共建文旅数字化生态圈，推动行业发展。',
      date: '08-02',
      year: '2022'
    }
  ],
  software: {
    smartTown: {
      title: '景区综合运营管理系统',
      sections: [
        {
          heading: '1. 票务与预约管理',
          content:
            '支持多渠道购票与分时预约，灵活设置限流规则。'
        },
        {
          heading: '2. 入园与客流监控',
          content:
            '通过闸机与摄像头数据实时掌握在园人数与区域热度。'
        },
        {
          heading: '3. 商户与业态管理',
          content:
            '统一管理景区内商户与业态布局，分析经营表现。'
        },
        {
          heading: '4. 游客服务中心',
          content:
            '提供失物招领、投诉建议与在线客服等多种服务入口。'
        }
      ]
    },
    bigData: {
      title: '文旅数据分析与营销平台',
      sections: [
        {
          heading: '1. 游客画像分析',
          desc:
            '通过多维数据构建游客画像，识别核心客群与潜力客群。'
        },
        {
          heading: '2. 营销活动效果评估',
          desc:
            '关联活动投放与客流变化情况，衡量活动带动效应。'
        },
        {
          heading: '3. 假期与淡旺季分析',
          desc:
            '对比不同时间段客流与消费表现，指导价格与活动策略。'
        },
        {
          heading: '4. 投诉与口碑监测',
          desc:
            '收集多渠道评价与投诉数据，为服务改进提供方向。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '景区数字化顶层设计',
      engTitle: 'Tourism Planning',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '票务与客流系统实施',
      engTitle: 'Ticketing Delivery',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '智慧导览与新媒体运营',
      engTitle: 'Guidance & Media',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '文旅数据分析顾问',
      engTitle: 'Tourism Analytics',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '文旅解决方案顾问',
    responsibilities: [
      '负责景区与文旅项目的方案设计与宣讲；',
      '深入理解客户需求，结合产品能力输出可落地方案；',
      '参与项目实施过程中的关键节点沟通。'
    ],
    requirements: [
      '熟悉文旅或景区行业，有相关项目经验者优先；',
      '具备良好的方案撰写与表达能力；',
      '能够适应出差，热爱旅游与文化产业。'
    ],
    buttonText: '加入项目团队'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-9.js